import { Dispatch } from 'redux';
import { SET_SELECTED_SECTION, SET_SELECTED_SIDEBAR_TAB } from '../types/types';
export const setTab = (selectedTab: string) => (dispatch: Dispatch) => {
	dispatch({
		type: SET_SELECTED_SIDEBAR_TAB,
		selectedTab: selectedTab
	});
};

export const setSelectedSection =
	(selectedSection: string) => (dispatch: Dispatch) => {
		dispatch({
			type: SET_SELECTED_SECTION,
			selectedSection: selectedSection
		});
	};
